/**
 * Heuristic: does an assistant reply express uncertainty / an "I don't know"?
 *
 * Used to render the "Let me check that for you" affordance below the message.
 * Deliberately conservative — false negatives (no chip on a mildly uncertain
 * reply) are better than false positives (chip on every reply).
 */
const UNCERTAIN_PATTERNS = [
  /\bi (?:don'?t|do not) (?:know|have)\b/i,
  /\bi'?m not (?:sure|certain)\b/i,
  /\bi cannot (?:confirm|verify)\b/i,
  /\bi can'?t (?:confirm|verify)\b/i,
  /\bnot (?:sure|certain) (?:about|if|whether)\b/i,
  /\bnot familiar with\b/i,
  /\bhaven'?t heard of\b/i,
  /\bno (?:information|info) (?:on|about)\b/i,
  /\bwant me to (?:look|check|verify|search)\b/i,
  /\blet me check\b/i,
  /\blook (?:it|that|this) up\b/i,
  /\bcould be (?:wrong|outdated)\b/i,
  /\bi (?:may|might) be (?:wrong|out of date)\b/i,
];

export function isUncertainReply(text) {
  if (!text || typeof text !== "string") return false;
  return UNCERTAIN_PATTERNS.some((p) => p.test(text));
}
